import { type MCPQueries, defMCPQueries } from '@kizen/query/mcp';

import AxiosService from 'services/AxiosService';

const queries: MCPQueries = defMCPQueries(AxiosService);

export const mcpServerListQuery: MCPQueries['mcpServerListQuery'] =
  queries.mcpServerListQuery;

export const mcpServerQuery: MCPQueries['mcpServerQuery'] =
  queries.mcpServerQuery;

export const mcpToolsQuery: MCPQueries['mcpToolsQuery'] = queries.mcpToolsQuery;

export const mcpServerHistoryQuery: MCPQueries['mcpServerHistoryQuery'] =
  queries.mcpServerHistoryQuery;

export const mcpServerStepOptionsQuery: MCPQueries['mcpServerStepOptionsQuery'] =
  queries.mcpServerStepOptionsQuery;
